<script setup lang="ts">
import KpiInfoCard from '@/components/kpi-chiffre-daffaires/KpiInfoCard.vue'
import KpiRepartition from '@/components/kpi-chiffre-daffaires/KpiRepartition.vue'
import ListePropositions from "@/components/ListePropositions.vue";
import DraggableContainer from '@/components/ui/draggable/DraggableContainer.vue'
import { useComponentOrder } from '@/lib/useComponentOrder'
import { markRaw } from 'vue'

const defaultComponents = [
  {
    id: 'info-card',
    component: markRaw(KpiInfoCard),
  },
  {
    id: 'repartition-card',
    component: markRaw(KpiRepartition),
  },
  {
    id: 'kpi-table',
    component: markRaw(ListePropositions),
  },
]

const { components } = useComponentOrder('kpi-chiffres-daffaires-page', defaultComponents)
</script>

<template>
  <DraggableContainer v-model:components="components" />
</template>
